export const WHATSAPP_URL = 'https://wa.me/5531992471052?text=Ol%C3%A1%21%20Vi%20seu%20site%2C%20gostaria%20de%20receber%20mais%20informa%C3%A7%C3%B5es.';
